<template>
  <div class="c-teikibin-accordion">
    <div class="c-teikibin-accordion__title" @click="toggleBodyOpen">
      <p class="c-teikibin-accordion__text" v-html="title"></p>
      <button
        type="button"
        class="c-teikibin-accordion__button"
        :class="{ isBodyOpen }"
      ></button>
    </div>
    <div class="c-teikibin-accordion__body" ref="body" :style="styleHeight">
      <div class="c-teikibin-accordion__text" v-html="body"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentsTeikibinAccordion',
  props: {
    title: { type: String, default: '' },
    body: { type: String, default: '' },
  },
  data() {
    return {
      isBodyOpen: false,
      styleHeight: { maxHeight: null },
    }
  },
  mounted() {
    this.height = this.$refs.body.clientHeight
    this.styleHeight.maxHeight = '0px'
  },
  methods: {
    toggleBodyOpen() {
      this.isBodyOpen = !this.isBodyOpen
      this.styleHeight.maxHeight = this.isBodyOpen ? `${this.height}px` : '0px'
    },
  },
}
</script>

<style lang="scss" scoped>
.c-teikibin-accordion {
  &__title,
  &__body {
    border-radius: 15px;
    padding: 0 15px 0 45px;
    margin: 10px 0;
    position: relative;

    &::before {
      color: var(--teikibin-theme-color);
      font-size: 15px;
      margin-right: 3px;
      position: absolute;
      left: 20px;
      top: 13px;
    }
  }

  &__text {
    padding: 15px 0;
  }

  &__title {
    background-color: #fff;
    cursor: pointer;
    padding-right: 55px;

    &::before {
      content: 'Q.';
    }
  }

  &__button {
    background-color: var(--teikibin-theme-color);
    width: 20px;
    height: 20px;
    border-radius: 10px;
    position: absolute;
    right: 20px;
    top: 0;
    bottom: 0;
    margin: auto;

    &::before,
    &::after {
      content: '';
      height: 1px;
      width: 8px;
      background-color: #fff;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }

    &::after {
      transition: 0.3s;
      transform: rotate(90deg);
    }

    &.isBodyOpen::after {
      transform: rotate(0);
    }
  }

  &__body {
    background-color: rgba(var(--teikibin-theme-color-rgb), 0.2);
    transition: 0.5s;
    overflow: hidden;

    &::before {
      content: 'A.';
    }
  }
}
</style>

<style lang="scss">
.c-teikibin-accordion {
  &__body {
    * + p,
    * + ul,
    * + ol {
      margin-top: 10px;
    }

    li::before {
      content: '・';
    }
  }
}
</style>
